import { defa }     from 'defa-object';
/**
 * defa.models.Finder
 * The DEFA Finder model.
 * @version 1.2.0
 */
import ControlModel from 'scripts/poppet/control-model';

const channel = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;

const api = {
	linkcom: apiHost + '/linkcom/',
	finder : '/finder/finder?attrs=',
	attrs  : 'finderActivated,gpsFix',
};

const Finder = ControlModel.extend( {
	
	url: function () {
		return api.linkcom + this.get( 'id' ) + api.finder + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend( {}, ControlModel.prototype.defaults,
		{
			finderActivated: null,
			finderActivatedError: null,
			
			gpsFixError: null,
			hasGps   : null,
			position : null,
			velocity : null,
		} ),
		
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			if(response.finderActivated){
				this.parseAttribute('finderActivated', response.finderActivated, options, newModelAttributes);
			}
			if(response.gpsFix){
				if('success' === response.gpsFix.status){
					newModelAttributes.gpsFixError = null;
					newModelAttributes.hasGps = response.gpsFix.value.hasGps;
					if(response.gpsFix.value.hasGps){
						newModelAttributes.position = response.gpsFix.value.position || '';
						newModelAttributes.velocity = response.gpsFix.value.velocity || '';
					}
				}else {
					newModelAttributes.gpsFixError = response.gpsFix.value;
				}
			}
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			channel.request( 'finders' ).add( newModelAttributes, { merge: true } );
		}
	},
	
	getLocation: function(){
		return {
			lat: this.get( 'position' ).latitude || 0,
			lng: this.get( 'position' ).longitude || 0,
		};
	},
	
	
	getSpeed: function(){
		return this.get('velocity').speed;
	},
	
	getTime: function(){
		let dateObject = new Date(this.get('position').timestamp);
		let time = dateObject.toTimeString().slice(0, 8);
		let date = dateObject.format('yyyy-mm-dd');
		return date + ' ' + time;
	},
	
	getDirection: function(){
		return this.get('velocity').direction;
	},
	
	getAccuracy: function(){
		return this.get('position').accuracy;
	},
	
	isLocationRetrieved: function(){
		return this.get('position') && this.hasValidData();
	},
	
	isGpsActiveRetrieved: function(){
		return this.get('finderActivated') && this.hasValidData();
	},
	
	isEntireModelRetrieved: function(){
		return this.isGpsActiveRetrieved() && this.get('hasGps') && this.isLocationRetrieved();
	},
	
	toBackendJSON: function() {
		return {finderActivated : this.get('finderActivated')};
	},
	
	getAttributes: function() {
		return api.attrs;
	},
	
	
} );

export default Finder;
